import { useRetrieveCollection } from "@hooks";
import Sponsor from "@models/sponsor";
import SponsorCard from "./SponsorCard";
import { AcadDirectory } from "@components";
import { useFirestore } from "reactfire";
import { collection, CollectionReference } from "firebase/firestore";
import { useTranslation } from "react-i18next";

const SponsorDirectory = () => {
  const db = useFirestore();
  const collectionRef = collection(
    db,
    Sponsor.PATH
  ) as CollectionReference<Sponsor>;

  const { data, error, loading } = useRetrieveCollection<Sponsor>({
    collectionRef,
  });

  const { t } = useTranslation("scholarships");

  return (
    <AcadDirectory
      loading={loading}
      error={error}
      hasData={(data?.docs?.length ?? 0) > 0}
      loadingEl={<SponsorCard sponsor={new Sponsor()} />}
      noDataEl={t("no_sponsors")}
    >
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4">
        {data?.docs.map((doc) => (
          <SponsorCard sponsor={doc.data()} key={doc.id} />
        ))}
      </div>
    </AcadDirectory>
  );
};

export default SponsorDirectory;
